var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.46 2C20.69 2.35 19.86 2.58 19 2.69C19.88 2.16 20.56 1.32 20.88 0.31C20.05 0.81 19.13 1.16 18.16 1.36C17.37 0.5 16.26 0 15 0C12.65 0 10.73 1.92 10.73 4.29C10.73 4.63 10.77 4.96 10.84 5.27C7.28001 5.09 4.11001 3.38 2.00001 0.79C1.63001 1.42 1.42001 2.16 1.42001 2.94C1.42001 4.43 2.17001 5.75 3.33001 6.5C2.62001 6.5 1.96001 6.3 1.38001 6V6.03C1.38001 8.11 2.86001 9.85 4.82001 10.24C4.19074 10.4122 3.5301 10.4362 2.89001 10.31C3.16162 11.1625 3.69355 11.9084 4.41103 12.4429C5.1285 12.9775 5.99546 13.2737 6.89001 13.29C5.37364 14.4904 3.494 15.1393 1.56001 15.13C1.22001 15.13 0.880009 15.11 0.540009 15.07C2.44001 16.29 4.70001 17 7.12001 17C15 17 19.33 10.46 19.33 4.79C19.33 4.6 19.33 4.42 19.32 4.23C20.16 3.63 20.88 2.87 21.46 2Z",
    fill: "#1DA1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social-twitter.2aff2eba88719b8d1944328f6a608c06.svg";
export { ForwardRef as ReactComponent };